{
  "audit_trail": {
    "button": {
      "text": "Audit Trail"
    },
    "modal": {
      "header": "Audit Trail"
    },
    "loading": {
      "aria_label": "loading audit trails"
    },
    "table": {
      "current": "Current"
    },
    "details": {
      "show_details_aria_label": "show details"
    },
    "actions": {
      "updated": "updated",
      "deleted": "deleted",
      "created": "created"
    },
    "entities": {
      "company_info": "company info",
      "company_key_contact": "key contact",
      "company_office_location": "office location",
      "contact_info": "contact",
      "contact": "contact",
      "contact_location": "contact location",
      "relationship_partner": "relationship partner",
      "contact_consent": "marketing consent",
      "note": "opportunity note",
      "opportunity": "opportunity",
      "company_document_file": "file"
    }
  }
}
